import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { Typography } from '@mui/material';
export var FormattedDescription = function (_a) {
    var htmlContent = _a.htmlContent;
    if (!htmlContent) {
        return null;
    }
    return (_jsx(Typography, { variant: "body2", color: "textSecondary", sx: { mb: 2 }, dangerouslySetInnerHTML: { __html: htmlContent } }));
};
